import EntitiesList from './EntitiesList';

export default EntitiesList;
